<template>
<div class="chapter">
<div class="inner_page">
<p class="epih"><a id="page_xi">The way you support yourself can be an expression of your deepest self, or it can be a source of suffering for you and others.</a></p><a id="page_xi">
</a><p class="epi-att"><a id="page_xi"><span class="txit">—Thich Nhat Hanh, Buddhist teacher</span></a><a id="page_xii"></a></p><a id="page_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?db099746